const GET_ZIP_DETAILS_FROM_API = 'GET_ZIP_DETAILS_FROM_API';
const GET_ZIP_DETAILS_SUCCESS = 'GET_ZIP_DETAILS_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const ASYNC_FETCH = 'ASYNC_FETCH';
const RUN_CREDIT_REVIEW = 'RUN_CREDIT_REVIEW';
const RUN_CREDIT_REVIEW_SUCCESS = 'RUN_CREDIT_REVIEW_SUCCESS';
const DEFAULT_ERR_MSG = 'We are unable to process the request at this time. Please try after sometime';
const GET_CREDIT_CHECK_INFO_ON_CLICK = 'GET_CONT_INFO_ON_CLICK';
const RUN_CREDIT_REVIEW_SUCCESS_DATA = 'RUN_CREDIT_REVIEW_SUCCESS_DATA';
const D2D_EID_SEND_MESSAGE_RESPONSE = 'D2D_EID_SEND_MESSAGE_RESPONSE';
const INITIATE_CREDIT_FAILED = 'INITIATE_CREDIT_FAILED';
const RUN_D2D_CREDIT_REVIEW = 'RUN_D2D_CREDIT_REVIEW';
const GET_DETAILS_FROM_API_SUCCESS = 'GET_DETAILS_FROM_API_SUCCESS';
const CC_INVALIDCASE_ERROR = 'CC_INVALIDCASE_ERROR';
const CEF_CREDIT_CHECK_ERROR = 'CEF_CREDIT_CHECK_ERROR';
const DEFAULT_ERROR_MESSAGE = 'Looks like something went wrong. Please try again later.';
const GET_AGREEMENT_DETAILS_CREDIT_PAGE = 'GET_AGREEMENT_DETAILS_CREDIT_PAGE';
const ORDERREVIEW_GET_CART_DETAILS_FROM_API = 'ORDERREVIEW_GET_CART_DETAILS_FROM_API';
const CREDIT_CHECK_LOADER_MESSAGES = [
  "Hold tight, we're checking your credit.",
  'Just a few more seconds...',
  'Almost there...',
];
const POST_EID_QUESTIONS_LOADER_MESSAGES = [
  'Processing your information',
  'Almost there',
  'Just a moment while we finish up',
];

export {
  GET_ZIP_DETAILS_FROM_API,
  GET_ZIP_DETAILS_SUCCESS,
  ERR_OCCURED,
  ASYNC_FETCH_SUCCESS,
  ASYNC_FETCH,
  RUN_CREDIT_REVIEW,
  RUN_CREDIT_REVIEW_SUCCESS,
  GET_CREDIT_CHECK_INFO_ON_CLICK,
  DEFAULT_ERR_MSG,
  RUN_CREDIT_REVIEW_SUCCESS_DATA,
  D2D_EID_SEND_MESSAGE_RESPONSE,
  INITIATE_CREDIT_FAILED,
  RUN_D2D_CREDIT_REVIEW,
  GET_DETAILS_FROM_API_SUCCESS,
  CC_INVALIDCASE_ERROR,
  CEF_CREDIT_CHECK_ERROR,
  DEFAULT_ERROR_MESSAGE,
  GET_AGREEMENT_DETAILS_CREDIT_PAGE,
  ORDERREVIEW_GET_CART_DETAILS_FROM_API,
  CREDIT_CHECK_LOADER_MESSAGES,
  POST_EID_QUESTIONS_LOADER_MESSAGES,
};
